import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { GraduationCap, UserCircle, Plus } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// "Add My Teachers" — shows the teachers a member has linked via "This person taught me".
export function MyTeachers({ userId, self }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!userId) return;
    api.get(`/users/${userId}/teachers`).then((r) => setRows(r.data.teachers || [])).catch(() => setRows([]));
  }, [userId]);

  if (rows === null) return null;
  if (rows.length === 0 && !self) return null;

  return (
    <Card className="mt-6 border-border/60 p-6 shadow-sm" data-testid="my-teachers">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-medium">
          <GraduationCap className="text-secondary" size={20} weight="duotone" /> {self ? "My Teachers" : "Teachers"}
        </h2>
        {self && (
          <Link to="/find-teacher">
            <Button size="sm" variant="outline" className="rounded-full gap-1.5" data-testid="add-my-teachers-btn"><Plus size={14} /> Add my teachers</Button>
          </Link>
        )}
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Honour the teachers who shaped you. <Link to="/find-teacher" className="text-primary hover:underline">Find a teacher</Link> and add them — it helps crowdsource decades of faculty history.
        </p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {rows.map((t) => (
            <Link key={t.id} to={t.person ? `/person/${t.person.id}` : "#"} data-testid={`my-teacher-${t.id}`}
              className="group flex items-start gap-3 rounded-xl border border-slate-100 bg-white p-3 shadow-sm transition-all hover:-translate-y-0.5 hover:border-green-300 hover:shadow-md">
              <span className="grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded-lg bg-green-50">
                {t.person?.photo_url ? <img src={t.person.photo_url} alt="" className="h-full w-full object-cover" /> : <UserCircle size={22} weight="duotone" className="text-green-600" />}
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium group-hover:text-primary">{t.person?.name || "A teacher"}</span>
                <span className="block truncate text-xs text-muted-foreground">{[t.subject, t.class_or_course, t.year_or_period].filter(Boolean).join(" · ")}{t.institution_name ? ` — ${t.institution_name}` : ""}</span>
              </span>
            </Link>
          ))}
        </div>
      )}
    </Card>
  );
}

export default MyTeachers;
